import { render, staticRenderFns } from "./KbaVerification.vue?vue&type=template&id=67b77248"
import script from "./KbaVerification.vue?vue&type=script&lang=js"
export * from "./KbaVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports